var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-container"},_vm._l((_vm.tabList),function(tab){return _c('div',{key:tab.value,staticClass:"tab-item",style:(_vm.chooseTab === tab.value && _vm.tabBg[tab.value]),on:{"click":function($event){return _vm.tabChange(tab)}}},[_vm._v(" "+_vm._s(tab.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }